import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { useDataLayer } from 'hooks/useDataLayer';
import { themeGet } from 'styled-system';
import { Flex, Link, Box } from 'roo-ui/components';
import { QFF_MY_ACCOUNT_URL, QH_SELF_SERVICE_URL, QFF_MY_PROFILE_URL, QFF_MY_POINTS_ACTIVITY_URL } from 'config';

const StyledLink = styled(Link)`
  color: ${themeGet('colors.greys.charcoal')};
  padding-left: ${themeGet('space.5')};
  margin-bottom: ${themeGet('space.2')};
`;

const StyledLinkWrapper = ({ eventValue, children }) => {
  const { emitInteractionEvent } = useDataLayer();

  const handleOnClick = useCallback(() => {
    emitInteractionEvent({ type: 'QFF Login Dropdown', value: `${eventValue} Selected` });
  }, [emitInteractionEvent, eventValue]);

  return <Box onClick={handleOnClick}>{children}</Box>;
};

StyledLinkWrapper.propTypes = {
  eventValue: PropTypes.string.isRequired,
  children: PropTypes.object.isRequired,
};

const QffLinks = () => {
  return (
    <Flex py={5} flexDirection="column">
      <StyledLinkWrapper eventValue="My Account">
        <StyledLink href={QFF_MY_ACCOUNT_URL} target="_blank" rel="noreferrer noopener" data-testid="my-account-link">
          My account
        </StyledLink>
      </StyledLinkWrapper>
      <StyledLinkWrapper eventValue="My Hotel Bookings">
        <StyledLink href={QH_SELF_SERVICE_URL} target="_blank" rel="noreferrer noopener" data-testid="my-bookings-link">
          My hotel bookings
        </StyledLink>
      </StyledLinkWrapper>
      <StyledLinkWrapper eventValue="My Points Activity">
        <StyledLink href={QFF_MY_POINTS_ACTIVITY_URL} target="_blank" rel="noreferrer noopener" data-testid="my-points-link">
          My points activity
        </StyledLink>
      </StyledLinkWrapper>
      <StyledLinkWrapper eventValue="My Profile">
        <StyledLink href={QFF_MY_PROFILE_URL} target="_blank" rel="noreferrer noopener" data-testid="my-profile-link">
          My profile
        </StyledLink>
      </StyledLinkWrapper>
    </Flex>
  );
};

export default QffLinks;
